// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1F2Of","productName":"Table_productName__2WYiu"};